export enum PAGES {
  FORM,
  SUCCESS,
}
